import React from 'react';
import slider2 from '../../../assets/images/educational_service/shield.jpg';
import slider1 from '../../../assets/images/educational_service/red_e.jpg';
import slider3 from '../../../assets/images/educational_service/tree_book.jpg';
import slider4 from '../../../assets/images/educational_service/puzzle.jpg';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';

function EducationalSupport() {
  const images = [
    {
      src: slider1,
      alt: 'Occupational therapy handwriting practice in Wasilla, Alaska',
    },
    {
      src: slider2,
      alt: 'Speech therapy articulation practice in Wasilla pediatric clinic',
    },
    {
      src: slider3,
      alt: 'Occupational therapy handwriting practice in Wasilla, Alaska',
    },
    {
      src: slider4,
      alt: 'Speech therapy articulation practice in Wasilla pediatric clinic',
    },
  ];

  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
        <div className="flex-[52%] flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 text-lg md:text-xl 2xl:text-2xl text-secondary">
          <h1 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
            Educational Support <br /> to improve quality of life.
          </h1>
          <p>
            At Guidepost Pediatrics, we are passionate about helping every child
            reach their full potential using state of art modalities in
            pediatric occupational, physical, and speech therapy. The Guidepost
            team, composed of dedicated, highly qualified professionals,
            specializes in pediatric therapies and educational support. We offer
            a range of services designed to address your child’s needs, bringing
            lasting changes and results to quality-of-life. We offer a warm and
            welcoming environment with therapeutic equipment and a sensory gym
            where neurodivergent children feel right at home.
          </p>
          <p>
            Explore our website to learn more about our services, meet our
            experienced staff, and discover how we can assist your child on an
            individualized path of growth and development. We would be honored
            to be a part of your child's journey and we look forward to serving
            you with exceptional care and expertise.
          </p>
        </div>
        <div className="flex-[48%] flex justify-center overflow-hidden relative">
          <CrossFadeImageSlider
            width="w-[90vw] md:w-[700px] 2xl:w-[500px] "
            height="h-[600px] 2xl:h-[670px]"
            images={images}
          />
        </div>
      </div>
    </div>
  );
}

export default EducationalSupport;
